import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const getFirebaseConfig = () => {
  if (typeof window !== 'undefined' && window.__firebase_config) {
    try {
      return typeof window.__firebase_config === 'string' 
        ? JSON.parse(window.__firebase_config) 
        : window.__firebase_config;
    } catch (e) {
      console.error("Failed to parse Firebase config", e);
    }
  }
  return {};
};

const app = initializeApp(getFirebaseConfig());

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const getAppId = () => {
  return (typeof window !== 'undefined' && window.__app_id) 
    ? window.__app_id 
    : 'job_quiz_matcher_v1';
};